<template>
	<div style="width: 90%;margin-left: 5%;">
		<div>
			<el-row :gutter="12">
			  <el-col :span="8">
			    <div>
			    	<el-card shadow="hover">
				      	<el-row>
				      		<el-col :span="16">
				      			<div>
				      				<div>
							      		新增设备(台)
							      	</div>
							      	<div>
							      		{{deviceNum}}
							      	</div>
				      			</div>
				      		</el-col>
				      		<el-col :span="8">
				      			<div>
				      				<img src="../../assets/images/datascreen1.png"/>
				      			</div>
				      		</el-col>
				      	</el-row>
				    </el-card>
			    </div>
			  </el-col>
			  <el-col :span="8">
			  	<div>
			    	<el-card shadow="hover">
				      	<el-row>
				      		<el-col :span="16">
				      			<div>
				      				<div>
							      		新增客户(人)
							      	</div>
							      	<div>
							      		{{userNum}}
							      	</div>
				      			</div>
				      		</el-col>
				      		<el-col :span="8">
				      			<div>
				      				<img src="../../assets/images/datascreen2.png"/>
				      			</div>
				      		</el-col>
				      	</el-row>
				    </el-card>
			    </div>
			  </el-col>
			  <el-col :span="8">
			  	<div>
			    	<el-card shadow="hover">
				      	<el-row>
				      		<el-col :span="16">
				      			<div>
				      				<div>
							      		新增收益(元)
							      	</div>
							      	<div>
							      		{{money}}
							      	</div>
				      			</div>
				      		</el-col>
				      		<el-col :span="8">
				      			<div>
				      				<img src="../../assets/images/datascreen3.png"/>
				      			</div>
				      		</el-col>
				      	</el-row>
				    </el-card>
			    </div>
			  </el-col>
			</el-row>
		</div>
		<div style="margin-top: 25px;">
			<el-card shadow="hover">
				<div>
					<div>
						<el-row>
							<el-col :span="12">
								<span>钱包</span>
							</el-col>
							<el-col :span="12">
								<el-select v-model="moneySelect" @change="moneySelectChange">
									<el-option value="0" label="过去7天"></el-option>
									<el-option value="1" label="过去30天"></el-option>
								</el-select>
							</el-col>
						</el-row>
					</div>
					<div>
						<div id="moneyDiv" style="margin-top: 10px;"></div>
					</div>
				</div>
			</el-card>
		</div>
		<div style="margin-top: 25px;" v-show="isVender">
			<el-row :gutter="12">
				<el-col :span="8">
					<el-card shadow="hover">
						<div>
							<span>分润占比</span>
						</div>
						<div>
							<div id="profileDiv" style="margin-top: 10px;"></div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="16">
					<el-card shadow="hover">
						<div>
							<span>设备地区分布(前五省份)</span>
						</div>
						<div>
							<div id="deviceLocalDiv" style="margin-top: 10px;width: 430px;"></div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import G2 from '@antv/g2';
import { View } from '@antv/data-set';
import axios from 'axios'

export default {
  name: 'dataScreen',
  components: {
  },
  data() {
    return {
    	deviceNum:300,
    	userNum:2453,
    	money:5978.22,
    	moneyData:[],
    	moneySelect:"0",
    	profileData:[],
    	profileSelect:"0",
    	deviceLocalData:[],
    	deviceLocalSelect:"0",
    	isVender:false
    }
  },
  mounted(){
  	var thiz = this;
  	axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do').then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				if(data.data.role == "4"){
					thiz.isVender = true;
				}
			    thiz.initPage();
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常,请与管理员联系!");
		});
  },
  created: function(){
  },
  methods: {
  	initPage(){
  		this.moneyData = [
  			{
  				time:"1/1",
  				money:1000,
  				order:1
  			},
  			{
  				time:"1/2",
  				money:2000,
  				order:3
  			},
  			{
  				time:"1/3",
  				money:5000,
  				order:8
  			},
  			{
  				time:"1/4",
  				money:4000,
  				order:3
  			},
  			{
  				time:"1/5",
  				money:8000,
  				order:6
  			},
  			{
  				time:"1/6",
  				money:9000,
  				order:5
  			},
  			{
  				time:"1/7",
  				money:10000,
  				order:10
  			}
  		]
  		this.initMoneyDiv();
  		this.profileData = [
  			{
  				role:"产家",
  				value:70
  			},
  			{
  				role:"一级代理商",
  				value:20
  			},
  			{
  				role:"二级代理商",
  				value:10
  			}
  		];
  		this.initProfileDiv();
  		this.deviceLocalData = [
  			{
  				"location":"North of Daguan, Yunnan, China",
		        "lat":"28.0",
		        "lng":"104.0",
		        "deviceNum":"18000"
  			},
  			{
  				"location":"Nan'ao, Guangdong (Kwangtung), China",
		        "lat":"23.5",
		        "lng":"117.2",
		        "deviceNum":"10000"
  			},
  			{
  				"location":"Near Luhuo, Sichuan (Szechwan), China",
		        "lat":"31.3",
		        "lng":"100.8",
		        "deviceNum":"13500"
  			},
  			{
  				"location":"Gulang, Gansu (Kansu), China",
		        "lat":"37.5",
		        "lng":"102.7",
		        "deviceNum":"20900"
  			},
  			{
  				"location":"Yangjiang, Guangdong, China",
		        "lat":"21.61",
		        "lng":"111.83",
		        "deviceNum":"13000"
  			}
  		];
  		var thiz = this;
  		axios.get('/china-provinces.geo.json')
  			.then(function (response) {
					var data = response.data;
					thiz.initDeviceLocalDiv(data)
				}).catch(function (error) {
					console.log(error);
					thiz.$message.error("系统异常!请与管理员联系!");
				});
  	},
  	moneySelectChange(){
  		console.log(this.moneySelect);
  	},
  	initMoneyDiv(){
  		var chart = new G2.Chart({
		  	container: 'moneyDiv',
		 	forceFit: true,
		  	height: 400,
		  	padding:[10,50,90,20]
		});
		chart.source(this.moneyData,{
			money:{
				alias:"收益(元)",
				min:0
			},
			order:{
				alias:"订单(个)",
				min:0
			}
		});
		chart.legend({
		  	custom: true,
		  	allowAllCanceled: true,
		  	position: 'bottom-center',
		  	items: [{
		    	value: '订单(个)',
		    	marker: {
		      	symbol: 'square',
		      	fill: '#3182bd',
		      	radius: 5
		    	}
		  	}, {
		    	value: '收益(元)',
		   	 	marker: {
		      	symbol: 'hyphen',
		      	stroke: '#fdae6b',
		      	radius: 5,
		      	lineWidth: 3
		    	}
		  	}]
		});
		chart.axis('money', {
		  	grid: null,
		  	label: {
		    textStyle: {
		      fill: '#fdae6b'
		    }
		  }
		});
		chart.interval().position('time*order').color('#3182bd');
		chart.line().position('time*money').color('#fdae6b').size(3).shape('smooth');
		chart.point().position('time*money').color('#fdae6b').size(3).shape('circle');
		chart.render();
  	},
  	initProfileDiv(){
  		var chart = new G2.Chart({
		  container: 'profileDiv',
		  forceFit: true,
		  height: 320,
		  padding: [0,10,90,10]
		});
		chart.source(this.profileData);
		chart.legend({
		  position: 'bottom-center'
		});
		chart.coord('theta', {
		  radius: 0.75
		});
		chart.tooltip({
		  showTitle: false
		});
		chart.intervalStack().position('value').color('role', ['#1890ff', '#37c661', '#fbce1e', '#2b3b79', '#8a4be2', '#1dc5c5']).style({
		  stroke: 'white',
		  lineWidth: 1
		}).label('value', function(val) {
		  if (val < 3) {
		    return null;
		  } else {
		    return {
		      offset: -30,
		      textStyle: {
		        fill: 'white',
		        fontSize: 14,
		        shadowBlur: 2,
		        shadowColor: 'rgba(0, 0, 0, .45)'
		      },
		      formatter: function formatter(text) {
		        return text + '%';
		      }
		    };
		  }
		});
		chart.render();
  	},
  	initDeviceLocalDiv(mapdata){
  		var chart = new G2.Chart({
	      container: 'deviceLocalDiv',
	      forceFit: true,
	      height: 320,
	      padding: 'auto'
	    });
	    // force sync scales
	    chart.scale({
	      x: {
	        sync: true,
	        nice: false
	      },
	      y: {
	        sync: true,
	        nice: false
	      }
	    });
	    chart.coord().reflect();
	    chart.legend(false);
	    chart.axis(false);
	
	    // style the tooltip
	    chart.tooltip({
	      showTitle: false,
	      containerTpl: '<div class="g2-tooltip"><table class="g2-tooltip-list"></table></div>',
	      itemTpl: '<tr data-index="{index}"><td style="padding:5px;background-color:#fff;">{name}</td><td style="padding:5px;background-color:#fff;color:#000;">{value}</td></tr>',
	      'g2-tooltip': {
	        borderRadius: '2px',
	        backgroundColor: '#DDDDDD',
	        padding: 0,
	        border: '1px solid #333'
	      }
	    });
	
	    // draw the map
	    var dv = new View('back').source(mapdata, {
	      type: 'GeoJSON'
	    }).transform({
	      type: 'geo.projection',
	      projection: 'geoMercator',
	      as: ['x', 'y', 'centroidX', 'centroidY']
	    });
	    var bgView = chart.view();
	    bgView.source(dv);
	    bgView.tooltip(false);
	    bgView.polygon().position('x*y').style({
	      fill: '#DDDDDD',
	      stroke: '#b1b1b1',
	      lineWidth: 0.5,
	      fillOpacity: 0.85
	    });
	
	    // draw the bubble plot
	    var userData = new View().source(this.deviceLocalData);
	    userData.transform({
	      type: 'map',
	      callback: function callback(obj) {
	        var projectedCoord = dv.geoProjectPosition([obj.lng * 1, obj.lat * 1], 'geoMercator');
	        obj.x = projectedCoord[0];
	        obj.y = projectedCoord[1];
	        obj.deviceNum = obj.deviceNum * 1;
	        return obj;
	      }
	    });
	    var pointView = chart.view();
	    pointView.source(userData);
	    pointView.point().position('x*y').size('deviceNum', [2, 30]).shape('circle').opacity(0.45).color('#FF2F29').tooltip('location*lat*lng*deviceNum');
	
	    chart.render();
  	}
  },
  computed:{
  }
}
</script>

<style>
  .el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .buttonClass{
  	font-size: 13px;
  	background-color: #009fe8;
  	color: #FFFFFF;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>